<template>
    <div class="rounded bg-gray-100 px-5 py-[2px] border-indigo-400 border-1">
        <slot/>
    </div>
</template>

<script>
export default {
    name: "Tag"
}
</script>
